<template>
  <div class="ai-selector">
    <section class="is-flex">
      <b-field
        class="m-1"
        :label="color"
        label-position="on-border"
        type="is-info"
      >
        <b-select v-model="selectedEngine" @input="onEngineChange">
          <option v-for="engine in engines" :key="engine" :value="engine">
            {{ engine }}
          </option>
        </b-select>
      </b-field>
      <b-field
        class="m-1"
        label="Level"
        label-position="on-border"
        type="is-info"
      >
        <b-select v-model="selectedLevel" @input="onLevelChange">
          <option v-for="(level, idx) in levels" :key="idx" :value="idx + 1">
            Level {{ idx + 1 }}
          </option>
        </b-select>
      </b-field>
    </section>
  </div>
</template>

<script>
import { CHESS_ENGINE, CHESS_ENGINES } from "vue-chess-shared/constants";
import { toAiProfile } from "vue-chess-shared/utils/ai-helper";
import { AI_RANDOM_RATE_BY_LEVEL } from "@/constants";

export default {
  name: "AiSelector",

  props: {
    color: {
      type: String,
      default: "",
    },
    defaultLevel: {
      type: Number,
      default: 1,
    },
    defaultEngine: {
      type: String,
      default: CHESS_ENGINE.STOCKFISH,
    },
  },

  data() {
    return {
      levels: AI_RANDOM_RATE_BY_LEVEL,
      engines: CHESS_ENGINES,
      selectedLevel: this.defaultLevel,
      selectedEngine: this.defaultEngine,
    };
  },

  methods: {
    onLevelChange() {
      this.$emit(
        "onChange",
        toAiProfile(this.selectedEngine, this.selectedLevel)
      );
    },
    onEngineChange() {
      this.$emit(
        "onChange",
        toAiProfile(this.selectedEngine, this.selectedLevel)
      );
    },
  },

  mounted() {
    this.$emit(
      "onChange",
      toAiProfile(this.selectedEngine, this.selectedLevel)
    );
  },
};
</script>
